// Remove whitespace from numerical string e.g. 1 500 -> 1500.
export function cleanNumericalString(value: string) {
  return value.replace(/\s/g, '');
}
